/* Built In Imports */

/* External Imports */
import { Box, Flex, Image } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Components */
import SimpleButton from '@components/HNI/Components/Buttons/SimpleButton';
import StructuredTextContent from '@components/UI/StructuredTextContent';

/**
 * Returns the Top Banner Event .
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Content from API
 * @param {string} region - Region of page
 * @param {string} language - Lang of page
 * @returns {ReactElement} TopBannerEvent component
 */

const TopBannerEvent = ({
  sectionContent,
  region,
  language,
  pageName,
  pageConfig,
  secImage,
}) => {
  const pName = pageConfig?.pageName;
  // const isMobile = useMediaQuery({ maxWidth: 960 });
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const styles = {
    default: 'polygon(0 0, 100% 0, 100% 100%, 0 83%)',
    'without-bottom-angle': '',
    '': 'polygon(0 0, 100% 0, 100% 100%, 0 83%)',
  };

  return (
    <Box
      display={'grid'}
      // mb={'70px'}
      pos={'relative'}
      h={{ base: '100%', md: '100%' }}
      // maxH={620}
      // minH={{ base: 550 }}
      bgColor={{
        base: '#231B05',
        md: 'transparent',
      }}
      _before={{
        content: "''",
        pos: 'absolute',
        width: '100%',
        right: '0',
        left: '0',
        height: '90%',
        bg: {
          base: 'linear-gradient(0deg, #231B05 65%, rgba(35, 27, 5, 0.00) 73.72%)',
          sm: 'linear-gradient(0deg, #231B05 55%, rgba(35, 27, 5, 0.00) 73.72%)',
          md: 'linear-gradient(0deg, #231B05 65%, rgba(35, 27, 5, 0.00) 73.72%)',
        },
        top: '10%',
        zIndex: '0',
        display: { base: 'block', md: 'none' },
      }}
      clipPath={{ base: 'polygon(0 0, 100% 0, 100% 100%, 0 95%)', md: 'none' }}
      pb="0"
    >
      <Box
        w={'100%'}
        h={{ base: '90vh', md: '60vh' }}
        maxH={{
          base: '800px',
          sm: '700px',
          md: '605px',
        }}
        minH="610px"
      >
        <Box
          alignItems={'center'}
          display={'flex'}
          height={{ base: '50%', md: '100%' }}
          backgroundRepeat="no-repeat"
          bgColor={{
            base: pageName === 'IDYPage' ? '#fffcf5' : '#f8f5f0',
            sm: 'transparent',
          }}
          backgroundSize={{ base: '100% 100%', sm: 'cover' }}
          // backgroundPosition={{
          //   base: '45%',
          //   sm: '45%',
          //   md: pageName === 'IDYPage' ? '100%' : '',
          //   lg: 'top center',
          //   xl: '0',
          // }}
          backgroundPosition={{
            base: 'center',
            sm: 'top center',
            md: 'center',
            xl: 'top center',
          }}
          backgroundImage={{
            md: sectionContent?.desktopImage?.url,
            base:
              sectionContent?.mobileImage?.url ||
              sectionContent?.desktopImage?.url,
            // ? show right of image in desktopImage when there is no mobileImage
          }}
          mb={{ base: '0', xl: '0' }}
          clipPath={{ md: styles[sectionContent.style] }}
        >
          {!isMobile && (
            <Flex
              flexDirection="column"
              verticalAlign={'center'}
              p={{
                base: '7px',
                md: '0 0 0 5%',
              }}
              w={{ base: '100%', sm: '100%', md: '50%' }}
              maxW={{
                base: 'auto',
                md: '44%',
              }}
              mt="-40px"
              fontSize={{
                sm: '44px',
                base: '30px',
              }}
              ml={{ lg: '5%' }}
              mb={{ lg: '6%' }}
              color={'#28231e'}
              fontFamily="FedraSansStd-A-medium"
              display={{
                base: 'none',
                sm: 'none',
                md: 'flex',
              }}
            >
              {/* {pageName === 'IDYPage' && (
                <Box fontSize={{ md: '18px' }} fontWeight="400">
                  UNESCO PRESENTS
                </Box>
              )} */}
              {secImage?._modelApiKey === 'single_image' && (
                <Image
                  src={secImage?.image?.url}
                  w={'260px'}
                  h={'50px'}
                  marginBottom={'37px'}
                />
              )}

              <Box
                as="h1"
                fontFamily={'FedraSansStd-medium'}
                color={'#FFFFFF'}
                //   lineHeight={pageName === 'ishanga7' ? '116%' : '1.25em'}
                lineHeight={{ lg: '54px' }}
                fontWeight={'500'}
                maxW={485}
                fontSize={{ base: '32px', md: '2rem' }}
              >
                {sectionContent?.title}
              </Box>

              {render(sectionContent.titleSubtext) &&
                render(sectionContent?.titleSubtext) !== '<p></p>' && (
                  <Box
                    fontSize={{
                      base: '16px',
                      md: language === 'en' ? '30px' : '20px',
                    }}
                    fontFamily="FedraSansStd-medium"
                    color="#B95C23"
                    mb={{ base: '8px', md: '15px' }}
                    letterSpacing="1px"
                  >
                    {StructuredTextContent(sectionContent.titleSubtext)}
                  </Box>
                )}
              {render(sectionContent?.description) &&
                render(sectionContent?.description) !== '<p></p>' && (
                  <Box
                    id="event-description"
                    fontSize={{
                      base: '16px',
                      md: language === 'en' ? '18px' : '12px',
                    }}
                    lineHeight={{ base: '24px', md: '28px' }}
                    fontFamily="FedraSansStd-book"
                    color={'#333333'}
                    w={'382px'}
                  >
                    {StructuredTextContent(sectionContent.description)}
                  </Box>
                )}
              {render(sectionContent?.date) &&
                render(sectionContent?.date) !== '<p></p>' && (
                  <Box
                    fontSize={{
                      base: '16px',
                      md:
                        language === 'en'
                          ? '22px'
                          : pName == 'hytt'
                          ? '24px'
                          : '18px',
                    }}
                    fontFamily="FedraSansStd-book"
                    fontWeight="500"
                    mt={2}
                    color={'#B95C23'}
                  >
                    {StructuredTextContent(sectionContent.date)}
                  </Box>
                )}
              {render(sectionContent?.closedMessage) &&
                render(sectionContent?.closedMessage) !== '<p></p>' && (
                  <Box
                    fontSize={{ base: '16px', md: '20px' }}
                    fontFamily="FedraSansStd-book"
                  >
                    {StructuredTextContent(sectionContent.closedMessage)}
                  </Box>
                )}
              {sectionContent?.button?.length > 0 && (
                <Box marginTop="10px" width={{ lg: '329px' }}>
                  <SimpleButton
                    style={sectionContent.button[0]}
                    region={region}
                    // bgColor={'#FFAB43'}
                    // _hover={{
                    //   bg: '#D04723',
                    //   color: '#FFFFFF',
                    // }}
                    color={'#28231E'}
                    lang={language}
                    mb="5px"
                    width={{ lg: '329px' }}
                    height={{ lg: '58px' }}
                    pageName={pageName}
                    pageConfig={pageConfig}
                  />
                </Box>
              )}

              {render(sectionContent?.bottomText) &&
                render(sectionContent?.bottomText) !== '<p></p>' && (
                  <Box
                    id="donate-button"
                    fontSize={{
                      base: '16px',
                      md: language === 'en' ? '16px' : '12px',
                    }}
                    fontFamily="FedraSansStd-book"
                    mb="10px"
                    mt="10px"
                    lineHeight="160%"
                  >
                    {StructuredTextContent(sectionContent.bottomText)}
                  </Box>
                )}

              {sectionContent?.secondaryCta?.length > 0 && (
                <Box marginTop="5px">
                  <SimpleButton
                    style={sectionContent.secondaryCta[0]}
                    region={region}
                    lang={language}
                    mb="5px"
                    minW={'200px'}
                    textAlign="center"
                    mt="0"
                    pageName={pageName}
                    pageConfig={pageConfig}
                    // disableButton={disableButton}
                  />
                </Box>
              )}
            </Flex>
          )}
        </Box>

        {isMobile && (
          <Flex
            display={{
              base: 'flex',
              sm: 'flex',
              md: 'flex',
              lg: 'none',
              xl: 'none',
            }}
            flexDirection="column"
            className="mobile"
            verticalAlign={'center'}
            w="100%"
            p={{
              base: '20px 15px 2.5rem',
              sm: '20px 15px',
              md: '30px',
            }}
            fontSize={{
              sm: '44px',
              base: '30px',
            }}
            textAlign="center"
            color={'#28231e'}
            pos="relative"
            zIndex="2"
            justifyContent="center"
            alignItems="center"
            mt={{ base: '-12%', sm: '5%', md: '-10%' }}
            fontFamily="FedraSansStd-A-medium"
            bgColor={{
              base: '#231B05',
              lg: 'transparent',
            }}
          >
            <Box maxW={485} mx="auto" w="100%">
              <Box
                as="h1"
                fontFamily="FedraSansStd-medium"
                px={{ base: '.5rem' }}
                fontSize={{
                  base: '24px',
                }}
                lineHeight={{
                  base: '38px',
                }}
                fontWeight={pName === 'hytt' ? '500' : '350'}
                color="#FFFFFF"
              >
                {sectionContent?.title}
              </Box>

              {sectionContent.titleSubtext && (
                <Box
                  fontSize={{ base: '20px', md: '28px', lg: '30px' }}
                  fontFamily="FedraSansStd-medium"
                  color="#B95C23"
                >
                  {StructuredTextContent(sectionContent.titleSubtext)}
                </Box>
              )}
              {render(sectionContent?.description) &&
                render(sectionContent?.description) !== '<p></p>' && (
                  <Box
                    id="event-description"
                    fontSize={{ base: '16px', md: '18px' }}
                    fontFamily="FedraSansStd-book"
                    color={pName == 'hytt' ? '#E9D5BD' : '#333333'}
                  >
                    {StructuredTextContent(sectionContent.description)}
                  </Box>
                )}
              {render(sectionContent?.date) &&
                render(sectionContent?.date) !== '<p></p>' && (
                  <Box
                    fontSize={{
                      base: pName === 'hytt' ? '20px' : '18px',
                      md: '20px',
                    }}
                    fontFamily="FedraSansStd-book"
                    fontWeight="500"
                    my={2}
                    color={pName == 'hytt' ? '#FFAE27' : '#B95C23'}
                  >
                    {StructuredTextContent(sectionContent.date)}
                  </Box>
                )}
              {render(sectionContent?.closedMessage) &&
                render(sectionContent?.closedMessage) !== '<p></p>' && (
                  <Box
                    fontSize={{ base: '16px', md: '20px' }}
                    fontFamily="FedraSansStd-book"
                    className={
                      pName === 'hytt' ? 'hytt-closemessage' : 'closeMessage'
                    }
                  >
                    {StructuredTextContent(sectionContent.closedMessage)}
                  </Box>
                )}
              {sectionContent?.button?.length > 0 && (
                <Box marginTop={{ base: '2.5rem', md: '18px' }} h="auto">
                  <SimpleButton
                    style={sectionContent.button[0]}
                    region={region}
                    // bgColor={'#FFAB43'}
                    // _hover={{
                    //   bg: '#D04723',
                    //   color: '#FFFFFF',
                    // }}
                    color={'#28231E'}
                    lang={language}
                    mx="auto"
                    mb={pageName === 'ishanga7' ? '10px' : '0'}
                    mt={pName === 'hytt' ? '0px' : '12px'}
                    pageName={pageName}
                    pageConfig={pageConfig}
                    // disableButton={disableButton}
                  />
                </Box>
              )}
              {render(sectionContent?.bottomText) &&
                render(sectionContent?.bottomText) !== '<p></p>' && (
                  <Box
                    id="donate-button"
                    fontSize={{ base: '16px', md: '20px' }}
                    fontFamily="FedraSansStd-book"
                    mb={sectionContent?.secondaryCta?.length ? '10px' : '0'}
                    mt={'10px'}
                  >
                    {StructuredTextContent(sectionContent.bottomText)}
                  </Box>
                )}
              {sectionContent?.secondaryCta?.length > 0 && (
                <Box mt="0">
                  <SimpleButton
                    style={sectionContent.secondaryCta[0]}
                    region={region}
                    lang={language}
                    mx="auto"
                    mb="15px"
                    minW={'200px'}
                    textAlign="center"
                    pageName={pageName}
                    pageConfig={pageConfig}
                    // disableButton={disableButton}
                  />
                </Box>
              )}
            </Box>
          </Flex>
        )}
      </Box>
      <style global jsx>
        {`
          #event-description h2 {
            font-size: 27px;
            color: #28231e;
            font-family: 'FedraSansStd-medium';
            padding: 15px 0 0 0;
          }
          {/* #donate-button a {
            color:#cf4520;
            text-decoration:underline;
          } */}
          #donate-button a:hover {
            text-decoration:none;
          }
          .closeMessage {
            color: black;
            margin-top: 5px;
            font-size: 16px;
          }
          .closeMessage a {
            color: #cf4824;
          }
          .hytt-closemessage {
            color:#90816E;
            margin-top: 5px;
            font-size: 16px;
          }

          @media (max-width: 767px) {
            #event-description h2 {
              font-size: 20px;
          }        
        `}
      </style>
    </Box>
  );
};

export default TopBannerEvent;
